'use client';
import React from 'react';
import { Menu } from 'lucide-react';

interface MobileHeaderProps {
  onMenuClick: () => void;
}

export default function MobileHeader({ onMenuClick }: MobileHeaderProps) {
  return (
    <header className="lg:hidden sticky top-0 z-10 bg-card border-b border-border px-3 py-2.5 flex items-center gap-3">
      <button
        onClick={onMenuClick}
        className="p-2.5 rounded-xl hover:bg-muted text-muted-foreground transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center"
        aria-label="Open menu"
      >
        <Menu size={22} />
      </button>
      <div className="flex items-center gap-2">
        <span className="text-[15px] font-bold tracking-tight">
          <span className="text-foreground">dropservice</span>
          <span className="text-primary">.in</span>
        </span>
      </div>
    </header>
  );
}